export const CompanyDetails = {
    SET_COMPANYDETAILS:"SET_CompanyDetails",
    SELECTED_COMPANYDETAILS: "SELECTED_COMPANYDETAILS",
    UPDATE_COMPANYDETAILS: "UPDATE_COMPANYDETAILS",
    ADD_COMPANYDATA: "ADD_COMPANYDATA",
    DELETE_COMPANYDATA: " DELETE_COMPANYDATA",

}
